module.exports = __webpack_public_path__ + "img/A-6595305-1531920049-5882.jpeg.c248975f.jpg";